import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { SpacePlayerSetupDto } from '@/types/dtos/player/response/av-sources.dto';

export const GET_SPACE_PLAYER_SETUP_QUERY_KEY = 'get-space-player-setup';

export const useGetSpacePlayerSetupQuery = (
  params?: { spaceId: string; eventId?: string },
  options?: { enabled?: boolean },
) => {
  const { getToken } = useAuth();
  const enabled = !!params?.spaceId && (options?.enabled ?? true);

  return useQuery({
    queryKey: [GET_SPACE_PLAYER_SETUP_QUERY_KEY, params?.spaceId, params?.eventId],
    queryFn: async () => {
      const token = await getToken();
      return getSpacePlayerSetup({ token: token ?? '', spaceId: params!.spaceId, eventId: params?.eventId });
    },
    enabled,
    staleTime: 5_000,
  });
};

const getSpacePlayerSetup = async ({
  token,
  spaceId,
  eventId,
}: {
  token: string;
  spaceId: string;
  eventId?: string;
}): Promise<SpacePlayerSetupDto> => {
  const params = new URLSearchParams({ spaceId });
  if (eventId) {
    params.set('eventId', eventId);
  }
  const url = `${import.meta.env.VITE_API_URL}/player/space-setup?${params.toString()}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
